import styled, { css } from "styled-components";
import Select from "ui/common/components/input/Select/Select";

export const ModalGiftCardsSelect = styled(Select)(
    () => css`
        .SelectDisplay {
            height: 3.75rem !important;
        }
    `,
) as typeof Select;
